export class LeagueStatus {
    constructor(data, config) {
        Object.defineProperty(this, "isLeagueParticipating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isParticipating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isTotaling", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentTier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueIcon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "remainingDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentRank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalingRemainingHours", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalingRemainingMinutes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isLeagueParticipating = data.isLeagueParticipating;
        this.isParticipating = data.isParticipating;
        this.isTotaling = data.isTotaling;
        this.currentTier = data.currentTier;
        this.leagueIcon = data.leagueIcon ? config.cdnBaseURL + data.leagueIcon : '';
        this.leagueTitle = data.leagueTitle;
        this.remainingDays = data.remainingDays;
        this.currentRank = data.currentRank;
        this.totalingRemainingHours = data.totalingRemainingHours;
        this.totalingRemainingMinutes = data.totalingRemainingMinutes;
    }
}
